import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 
    "email", "form", "success", "successText"
  ]

  connect() {
    window.newsletterCaptchaCallback = (token) => {
      this.submitWithCaptcha(token);
    }
  }

  submitWithCaptcha(token) {
    $.ajax({
      type: "POST",
      url: "/newsletter_optins",
      data: {
        "g-recaptcha-response": token,
        email: $(this.emailTarget).val()
      },
      success: (data) => {
        if(data.status == "ok") {
          $(this.formTarget).slideUp();
          $(this.successTextTarget).text(data.message);
          $(this.successTarget).slideDown();
        }
        else {
          alert(data.message);
        }
      },
      error: (e) => {
        if(e.status == 422 && e.responseJSON && e.responseJSON.message) {
          alert(e.responseJSON.message);
        }
        else {
          alert("Error: " + e.status + ". Please try again or contact team@remove.bg if the problem persists.");
        }
        grecaptcha.reset();
      }
    });
  }

}
